"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UP = exports.RESIZE_TIMEOUT = exports.MINIMUM_RESIZE_CELL_WIDTH = exports.FILTER_INPUT_ID = exports.DRAG_TIMEOUT = exports.DOWN = exports.DESC = exports.CLASS_WIDTHS_SET = exports.ASC = exports.ADD_FILTER_DATA_TIMEOUT = void 0;
var MINIMUM_RESIZE_CELL_WIDTH = 40;
exports.MINIMUM_RESIZE_CELL_WIDTH = MINIMUM_RESIZE_CELL_WIDTH;
var RESIZE_TIMEOUT = 200;
exports.RESIZE_TIMEOUT = RESIZE_TIMEOUT;
var DRAG_TIMEOUT = 150;
exports.DRAG_TIMEOUT = DRAG_TIMEOUT;
var CLASS_WIDTHS_SET = [[80, 80], [160, 160], [240, 240], [320, 320], [400, 400]];
exports.CLASS_WIDTHS_SET = CLASS_WIDTHS_SET;
var DESC = 'desc';
exports.DESC = DESC;
var ASC = 'asc';
exports.ASC = ASC;
var UP = 'up';
exports.UP = UP;
var DOWN = 'down';
exports.DOWN = DOWN;
var ADD_FILTER_DATA_TIMEOUT = 400;
exports.ADD_FILTER_DATA_TIMEOUT = ADD_FILTER_DATA_TIMEOUT;
var FILTER_INPUT_ID = 'grid-header-filter';
exports.FILTER_INPUT_ID = FILTER_INPUT_ID;